import { render } from "./Payment-page.vue?vue&type=template&id=aabb0e0e&scoped=true"
import script from "./Payment-page.vue?vue&type=script&lang=js"
export * from "./Payment-page.vue?vue&type=script&lang=js"

import "./Payment-page.vue?vue&type=style&index=0&id=aabb0e0e&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aabb0e0e"]])

export default __exports__